export default {
    initialStudentCount: 3,
    navItems: [
        {
            id: 'student-program',
            title: 'Program',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-folder-home',
            class: 'warning--text text--darken-1',
            component: 'student-program',
            params: {
                sessions: 'sessions',
                programs: 'programs',
            },
            source: 'currentStudent',
            maxHeight: 600,
            layout: 'main',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Program Admin',
                'Instructor',
                'Student',
            ],
            colsClass: 'col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12',
        },
        {
            id: 'student-instructor',
            title: 'Instructor',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-account-box',
            class: 'warning--text text--darken-1',
            component: 'student-instructor',
            params: {
                instructor: 'instructor',
            },
            source: 'currentStudent',
            maxHeight: 600,
            layout: 'main',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Program Admin',
                'Instructor',
                'Student',
            ],
            colsClass: 'col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12',
        },
        {
            id: 'student-info',
            title: 'Student Info',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-account-box',
            class: 'warning--text text--darken-1',
            component: 'student-info',
            params: {
                student: 'currentStudent',
            },
            source: 'currentStudent',
            maxHeight: 600,
            layout: 'main',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Program Admin',
                'Instructor',
                'Student',
            ],
            colsClass: 'col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12',
        },
    ],
    processLayouts: {
        student: [
            {
                id: 'student-program',
                laout: 'main',
            },
            {
                id: 'student-instructor',
                laout: 'main',
            },
            {
                id: 'student-info',
                laout: 'main',
            },
        ],
    },
    pagination: {
        perPage: 50,
        perPageOptions: [10, 25, 50, 100, 200],
    },
};
